const textToHtml = (text) => document.createRange().createContextualFragment(text);

export default textToHtml;
